// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("bs-platform/lib/js/curry.js");
var React = require("react");
var Belt_Map = require("bs-platform/lib/js/belt_Map.js");
var Belt_List = require("bs-platform/lib/js/belt_List.js");
var Debouncer = require("re-debouncer/src/Debouncer.bs.js");
var Belt_Option = require("bs-platform/lib/js/belt_Option.js");
var Caml_option = require("bs-platform/lib/js/caml_option.js");
var FormalityCompat__ReactUpdate = require("./FormalityCompat__ReactUpdate.bs.js");

function Make(Form) {
  var FieldId = Form.FieldId;
  var debounce = function (wait, validate) {
    var fn = function (param) {
      var dispatch = param[2];
      var input = param[1];
      var field = param[0];
      var __x = Curry._1(validate, input);
      __x.then(function (result) {
            Curry._1(dispatch, {
                  TAG: /* ApplyAsyncResult */2,
                  _0: field,
                  _1: input,
                  _2: result
                });
            return Promise.resolve(undefined);
          });
      
    };
    return Debouncer.make(wait, fn);
  };
  var getInitialState = function (input) {
    return {
            input: input,
            status: /* Editing */0,
            fields: Belt_List.reduce(Form.validators, Belt_Map.make(FieldId), (function (fields, validator) {
                    return Belt_Map.set(fields, validator.field, /* Pristine */0);
                  })),
            validators: {
              contents: Belt_List.reduce(Form.validators, Belt_Map.make(FieldId), (function (validators, validator) {
                      return Belt_Map.set(validators, validator.field, {
                                  field: validator.field,
                                  strategy: validator.strategy,
                                  dependents: validator.dependents,
                                  validate: validator.validate,
                                  validateAsync: Belt_Option.map(validator.validateAsync, (function (param) {
                                          return [
                                                  debounce(Form.debounceInterval, param[0]),
                                                  param[1]
                                                ];
                                        }))
                                });
                    }))
            },
            submittedOnce: false
          };
  };
  var useForm = function (initialState, onSubmit) {
    var memoizedInitialState = React.useMemo((function () {
            return getInitialState(initialState);
          }), [initialState]);
    var match = FormalityCompat__ReactUpdate.useReducer(memoizedInitialState, (function (state, action) {
            if (typeof action === "number") {
              switch (action) {
                case /* Submit */0 :
                    var match = state.status;
                    if (typeof match !== "number" && match.TAG === /* Submitting */0) {
                      return /* NoUpdate */0;
                    }
                    var match$1 = Belt_Map.reduce(state.validators.contents, [
                          true,
                          state.fields,
                          false
                        ], (function (param, field, validator) {
                            var fields = param[1];
                            var valid = param[0];
                            var status = Belt_Map.get(fields, field);
                            var exit = 0;
                            if (param[2]) {
                              return [
                                      valid,
                                      fields,
                                      true
                                    ];
                            }
                            if (status !== undefined && typeof status === "number") {
                              if (status !== 0) {
                                return [
                                        valid,
                                        fields,
                                        true
                                      ];
                              }
                              exit = 1;
                            } else {
                              exit = 1;
                            }
                            if (exit === 1) {
                              var currentResultIsInvalid = status !== undefined && !(typeof status === "number" || status._0.TAG === /* Ok */0) ? true : false;
                              var result = Curry._1(validator.validate, state.input);
                              var match = validator.validateAsync;
                              var fields$1;
                              var exit$1 = 0;
                              if (currentResultIsInvalid && result.TAG === /* Ok */0 && !(result._0 || match === undefined)) {
                                fields$1 = fields;
                              } else {
                                exit$1 = 2;
                              }
                              if (exit$1 === 2) {
                                fields$1 = Belt_Map.set(fields, field, /* Dirty */{
                                      _0: result,
                                      _1: /* Shown */0
                                    });
                              }
                              var match$1 = Belt_Map.get(fields$1, field);
                              if (valid && !(match$1 !== undefined && !(typeof match$1 === "number" || match$1._0.TAG === /* Ok */0))) {
                                return [
                                        true,
                                        fields$1,
                                        false
                                      ];
                              } else {
                                return [
                                        false,
                                        fields$1,
                                        false
                                      ];
                              }
                            }
                            
                          }));
                    if (match$1[2]) {
                      return /* NoUpdate */0;
                    }
                    var fields = match$1[1];
                    if (!match$1[0]) {
                      return {
                              TAG: /* Update */0,
                              _0: {
                                input: state.input,
                                status: /* Editing */0,
                                fields: fields,
                                validators: state.validators,
                                submittedOnce: true
                              }
                            };
                    }
                    var error = state.status;
                    var tmp;
                    tmp = typeof error === "number" || error.TAG !== /* SubmissionFailed */1 ? undefined : Caml_option.some(error._0);
                    return {
                            TAG: /* UpdateWithSideEffects */1,
                            _0: {
                              input: state.input,
                              status: {
                                TAG: /* Submitting */0,
                                _0: tmp
                              },
                              fields: fields,
                              validators: state.validators,
                              submittedOnce: true
                            },
                            _1: (function (param) {
                                var dispatch = param.dispatch;
                                return Curry._2(onSubmit, param.state.input, {
                                            notifyOnSuccess: (function (data) {
                                                return Curry._1(dispatch, {
                                                            TAG: /* SetSubmittedStatus */3,
                                                            _0: data
                                                          });
                                              }),
                                            notifyOnFailure: (function (error) {
                                                return Curry._1(dispatch, {
                                                            TAG: /* SetSubmissionFailedStatus */4,
                                                            _0: error
                                                          });
                                              }),
                                            reset: (function (param) {
                                                return Curry._1(dispatch, /* Reset */3);
                                              }),
                                            dismissSubmissionResult: (function (param) {
                                                return Curry._1(dispatch, /* DismissSubmissionResult */2);
                                              })
                                          });
                              })
                          };
                    break;
                case /* DismissSubmissionError */1 :
                    var match$2 = state.status;
                    if (typeof match$2 === "number" || match$2.TAG !== /* SubmissionFailed */1) {
                      return /* NoUpdate */0;
                    } else {
                      return {
                              TAG: /* Update */0,
                              _0: {
                                input: state.input,
                                status: /* Editing */0,
                                fields: state.fields,
                                validators: state.validators,
                                submittedOnce: state.submittedOnce
                              }
                            };
                    }
                case /* DismissSubmissionResult */2 :
                    var match$3 = state.status;
                    if (typeof match$3 === "number") {
                      if (match$3 === /* Editing */0) {
                        return /* NoUpdate */0;
                      }
                      
                    } else if (match$3.TAG === /* Submitting */0) {
                      return /* NoUpdate */0;
                    }
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              status: /* Editing */0,
                              fields: state.fields,
                              validators: state.validators,
                              submittedOnce: state.submittedOnce
                            }
                          };
                case /* Reset */3 :
                    return {
                            TAG: /* Update */0,
                            _0: getInitialState(initialState)
                          };
                
              }
            } else {
              switch (action.TAG | 0) {
                case /* Change */0 :
                    var input = action._1;
                    var field = action._0;
                    var validator = Belt_Map.get(state.validators.contents, field);
                    if (validator === undefined) {
                      return {
                              TAG: /* Update */0,
                              _0: {
                                input: input,
                                status: state.status,
                                fields: Belt_Map.set(state.fields, field, /* Dirty */{
                                      _0: {
                                        TAG: /* Ok */0,
                                        _0: /* Valid */0
                                      },
                                      _1: /* Hidden */1
                                    }),
                                validators: state.validators,
                                submittedOnce: state.submittedOnce
                              }
                            };
                    }
                    var status = Belt_Map.get(state.fields, field);
                    var result = Curry._1(validator.validate, input);
                    var dependents = validator.dependents;
                    var fields$1 = dependents !== undefined ? Belt_List.reduce(dependents, state.fields, (function (fields, field) {
                              var status = Belt_Map.get(fields, field);
                              if (status === undefined) {
                                return fields;
                              }
                              if (typeof status === "number") {
                                return fields;
                              }
                              if (status._1) {
                                return fields;
                              }
                              var validator = Belt_Map.getExn(state.validators.contents, field);
                              return Belt_Map.set(fields, field, /* Dirty */{
                                          _0: Curry._1(validator.validate, input),
                                          _1: /* Shown */0
                                        });
                            })) : state.fields;
                    var match$4 = validator.strategy;
                    var match$5 = state.submittedOnce;
                    var exit = 0;
                    var exit$1 = 0;
                    if (status !== undefined && !(typeof status === "number" || status._1)) {
                      exit = 3;
                    } else {
                      exit$1 = 4;
                    }
                    if (exit$1 === 4) {
                      if (match$5) {
                        exit = 3;
                      } else {
                        switch (match$4) {
                          case /* OnFirstChange */1 :
                              exit = 3;
                              break;
                          case /* OnFirstSuccess */2 :
                          case /* OnFirstSuccessOrFirstBlur */3 :
                              exit = 1;
                              break;
                          case /* OnFirstBlur */0 :
                          case /* OnSubmit */4 :
                              exit = 2;
                              break;
                          
                        }
                      }
                    }
                    switch (exit) {
                      case 1 :
                          var match$6 = validator.validateAsync;
                          if (result.TAG !== /* Ok */0) {
                            return {
                                    TAG: /* Update */0,
                                    _0: {
                                      input: input,
                                      status: state.status,
                                      fields: Belt_Map.set(fields$1, field, /* Dirty */{
                                            _0: result,
                                            _1: /* Hidden */1
                                          }),
                                      validators: state.validators,
                                      submittedOnce: state.submittedOnce
                                    }
                                  };
                          }
                          var exit$2 = 0;
                          if (result._0) {
                            if (match$6 !== undefined) {
                              return {
                                      TAG: /* Update */0,
                                      _0: {
                                        input: input,
                                        status: state.status,
                                        fields: Belt_Map.set(fields$1, field, /* Dirty */{
                                              _0: result,
                                              _1: /* Shown */0
                                            }),
                                        validators: state.validators,
                                        submittedOnce: state.submittedOnce
                                      }
                                    };
                            }
                            exit$2 = 4;
                          } else {
                            if (match$6 !== undefined) {
                              var validateAsync = match$6[0];
                              return {
                                      TAG: /* UpdateWithSideEffects */1,
                                      _0: {
                                        input: input,
                                        status: state.status,
                                        fields: Belt_Map.set(fields$1, field, /* Validating */1),
                                        validators: state.validators,
                                        submittedOnce: state.submittedOnce
                                      },
                                      _1: (function (param) {
                                          return Curry._1(validateAsync, [
                                                      field,
                                                      input,
                                                      param.dispatch
                                                    ]);
                                        })
                                    };
                            }
                            exit$2 = 4;
                          }
                          if (exit$2 === 4) {
                            return {
                                    TAG: /* Update */0,
                                    _0: {
                                      input: input,
                                      status: state.status,
                                      fields: Belt_Map.set(fields$1, field, /* Dirty */{
                                            _0: result,
                                            _1: /* Shown */0
                                          }),
                                      validators: state.validators,
                                      submittedOnce: state.submittedOnce
                                    }
                                  };
                          }
                          break;
                      case 2 :
                          return {
                                  TAG: /* Update */0,
                                  _0: {
                                    input: input,
                                    status: state.status,
                                    fields: Belt_Map.set(fields$1, field, /* Dirty */{
                                          _0: result,
                                          _1: /* Hidden */1
                                        }),
                                    validators: state.validators,
                                    submittedOnce: state.submittedOnce
                                  }
                                };
                      case 3 :
                          var match$7 = validator.validateAsync;
                          var exit$3 = 0;
                          if (match$7 === undefined) {
                            return {
                                    TAG: /* Update */0,
                                    _0: {
                                      input: input,
                                      status: state.status,
                                      fields: Belt_Map.set(fields$1, field, /* Dirty */{
                                            _0: result,
                                            _1: /* Shown */0
                                          }),
                                      validators: state.validators,
                                      submittedOnce: state.submittedOnce
                                    }
                                  };
                          }
                          if (result.TAG === /* Ok */0 && !result._0) {
                            var validateAsync$1 = match$7[0];
                            return {
                                    TAG: /* UpdateWithSideEffects */1,
                                    _0: {
                                      input: input,
                                      status: state.status,
                                      fields: Belt_Map.set(fields$1, field, /* Validating */1),
                                      validators: state.validators,
                                      submittedOnce: state.submittedOnce
                                    },
                                    _1: (function (param) {
                                        return Curry._1(validateAsync$1, [
                                                    field,
                                                    input,
                                                    param.dispatch
                                                  ]);
                                      })
                                  };
                          }
                          exit$3 = 4;
                          if (exit$3 === 4) {
                            return {
                                    TAG: /* Update */0,
                                    _0: {
                                      input: input,
                                      status: state.status,
                                      fields: Belt_Map.set(fields$1, field, /* Dirty */{
                                            _0: result,
                                            _1: /* Shown */0
                                          }),
                                      validators: state.validators,
                                      submittedOnce: state.submittedOnce
                                    }
                                  };
                          }
                          break;
                      
                    }
                    break;
                case /* Blur */1 :
                    var field$1 = action._0;
                    var status$1 = Belt_Map.get(state.fields, field$1);
                    var validator$1 = Belt_Map.get(state.validators.contents, field$1);
                    var exit$4 = 0;
                    var exit$5 = 0;
                    if (status$1 !== undefined) {
                      if (typeof status$1 === "number") {
                        if (status$1 !== 0) {
                          return /* NoUpdate */0;
                        }
                        exit$5 = 2;
                      } else {
                        if (!status$1._1) {
                          return /* NoUpdate */0;
                        }
                        if (validator$1 === undefined) {
                          return /* NoUpdate */0;
                        }
                        exit$4 = 1;
                      }
                    } else {
                      exit$5 = 2;
                    }
                    if (exit$5 === 2) {
                      if (validator$1 === undefined) {
                        return {
                                TAG: /* Update */0,
                                _0: {
                                  input: state.input,
                                  status: state.status,
                                  fields: Belt_Map.set(state.fields, field$1, /* Dirty */{
                                        _0: {
                                          TAG: /* Ok */0,
                                          _0: /* Valid */0
                                        },
                                        _1: /* Hidden */1
                                      }),
                                  validators: state.validators,
                                  submittedOnce: state.submittedOnce
                                }
                              };
                      }
                      exit$4 = 1;
                    }
                    if (exit$4 === 1) {
                      var result$1 = Curry._1(validator$1.validate, state.input);
                      var match$8 = validator$1.strategy;
                      var exit$6 = 0;
                      if (match$8 !== 3) {
                        if (match$8 !== 0) {
                          return {
                                  TAG: /* Update */0,
                                  _0: {
                                    input: state.input,
                                    status: state.status,
                                    fields: Belt_Map.set(state.fields, field$1, /* Dirty */{
                                          _0: result$1,
                                          _1: /* Hidden */1
                                        }),
                                    validators: state.validators,
                                    submittedOnce: state.submittedOnce
                                  }
                                };
                        }
                        exit$6 = 2;
                      } else {
                        exit$6 = 2;
                      }
                      if (exit$6 === 2) {
                        var match$9 = validator$1.validateAsync;
                        var exit$7 = 0;
                        if (match$9 === undefined) {
                          return {
                                  TAG: /* Update */0,
                                  _0: {
                                    input: state.input,
                                    status: state.status,
                                    fields: Belt_Map.set(state.fields, field$1, /* Dirty */{
                                          _0: result$1,
                                          _1: /* Shown */0
                                        }),
                                    validators: state.validators,
                                    submittedOnce: state.submittedOnce
                                  }
                                };
                        }
                        if (result$1.TAG === /* Ok */0 && !result$1._0) {
                          var validateAsync$2 = match$9[0];
                          return {
                                  TAG: /* UpdateWithSideEffects */1,
                                  _0: {
                                    input: state.input,
                                    status: state.status,
                                    fields: Belt_Map.set(state.fields, field$1, /* Validating */1),
                                    validators: state.validators,
                                    submittedOnce: state.submittedOnce
                                  },
                                  _1: (function (param) {
                                      return Curry._1(validateAsync$2, [
                                                  field$1,
                                                  state.input,
                                                  param.dispatch
                                                ]);
                                    })
                                };
                        }
                        exit$7 = 3;
                        if (exit$7 === 3) {
                          return {
                                  TAG: /* Update */0,
                                  _0: {
                                    input: state.input,
                                    status: state.status,
                                    fields: Belt_Map.set(state.fields, field$1, /* Dirty */{
                                          _0: result$1,
                                          _1: /* Shown */0
                                        }),
                                    validators: state.validators,
                                    submittedOnce: state.submittedOnce
                                  }
                                };
                        }
                        
                      }
                      
                    }
                    break;
                case /* ApplyAsyncResult */2 :
                    var field$2 = action._0;
                    var validator$2 = Belt_Map.getExn(state.validators.contents, field$2);
                    var eq = Belt_Option.getExn(validator$2.validateAsync)[1];
                    if (Curry._2(eq, action._1, state.input)) {
                      return {
                              TAG: /* Update */0,
                              _0: {
                                input: state.input,
                                status: state.status,
                                fields: Belt_Map.set(state.fields, field$2, /* Dirty */{
                                      _0: action._2,
                                      _1: /* Shown */0
                                    }),
                                validators: state.validators,
                                submittedOnce: state.submittedOnce
                              }
                            };
                    } else {
                      return /* NoUpdate */0;
                    }
                case /* SetSubmittedStatus */3 :
                    var data = action._0;
                    if (data !== undefined) {
                      return {
                              TAG: /* Update */0,
                              _0: {
                                input: Caml_option.valFromOption(data),
                                status: /* Submitted */1,
                                fields: Belt_Map.map(state.fields, (function (param) {
                                        return /* Pristine */0;
                                      })),
                                validators: state.validators,
                                submittedOnce: state.submittedOnce
                              }
                            };
                    } else {
                      return {
                              TAG: /* Update */0,
                              _0: {
                                input: state.input,
                                status: /* Submitted */1,
                                fields: Belt_Map.map(state.fields, (function (param) {
                                        return /* Pristine */0;
                                      })),
                                validators: state.validators,
                                submittedOnce: state.submittedOnce
                              }
                            };
                    }
                case /* SetSubmissionFailedStatus */4 :
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              status: {
                                TAG: /* SubmissionFailed */1,
                                _0: action._0
                              },
                              fields: state.fields,
                              validators: state.validators,
                              submittedOnce: state.submittedOnce
                            }
                          };
                case /* MapSubmissionError */5 :
                    var map = action._0;
                    var error$1 = state.status;
                    if (typeof error$1 === "number") {
                      return /* NoUpdate */0;
                    }
                    if (error$1.TAG !== /* Submitting */0) {
                      return {
                              TAG: /* Update */0,
                              _0: {
                                input: state.input,
                                status: {
                                  TAG: /* SubmissionFailed */1,
                                  _0: Curry._1(map, error$1._0)
                                },
                                fields: state.fields,
                                validators: state.validators,
                                submittedOnce: state.submittedOnce
                              }
                            };
                    }
                    var error$2 = error$1._0;
                    if (error$2 !== undefined) {
                      return {
                              TAG: /* Update */0,
                              _0: {
                                input: state.input,
                                status: {
                                  TAG: /* Submitting */0,
                                  _0: Caml_option.some(Curry._1(map, Caml_option.valFromOption(error$2)))
                                },
                                fields: state.fields,
                                validators: state.validators,
                                submittedOnce: state.submittedOnce
                              }
                            };
                    } else {
                      return /* NoUpdate */0;
                    }
                
              }
            }
          }));
    var dispatch = match[1];
    var state = match[0];
    var match$1 = state.status;
    var tmp;
    tmp = typeof match$1 === "number" || match$1.TAG !== /* Submitting */0 ? false : true;
    return {
            state: state.input,
            status: state.status,
            result: (function (field) {
                var match = Belt_Map.get(state.fields, field);
                if (match !== undefined && !(typeof match === "number" || match._1)) {
                  return match._0;
                }
                
              }),
            dirty: (function (param) {
                return Belt_Map.some(state.fields, (function (param, status) {
                              if (typeof status === "number") {
                                return status !== 0;
                              } else {
                                return true;
                              }
                            }));
              }),
            validating: (function (field) {
                var match = Belt_Map.get(state.fields, field);
                if (match !== undefined && typeof match === "number") {
                  return match !== 0;
                } else {
                  return false;
                }
              }),
            submitting: tmp,
            change: (function (field, state) {
                return Curry._1(dispatch, {
                            TAG: /* Change */0,
                            _0: field,
                            _1: state
                          });
              }),
            blur: (function (field) {
                return Curry._1(dispatch, {
                            TAG: /* Blur */1,
                            _0: field
                          });
              }),
            submit: (function (param) {
                return Curry._1(dispatch, /* Submit */0);
              }),
            mapSubmissionError: (function (map) {
                return Curry._1(dispatch, {
                            TAG: /* MapSubmissionError */5,
                            _0: map
                          });
              }),
            dismissSubmissionError: (function (param) {
                return Curry._1(dispatch, /* DismissSubmissionError */1);
              }),
            dismissSubmissionResult: (function (param) {
                return Curry._1(dispatch, /* DismissSubmissionResult */2);
              }),
            reset: (function (param) {
                return Curry._1(dispatch, /* Reset */3);
              })
          };
  };
  return {
          FieldId: FieldId,
          debounce: debounce,
          getInitialState: getInitialState,
          useForm: useForm
        };
}

var Validation;

var Strategy;

var FormStatus;

var ReactUpdate;

var defaultDebounceInterval = 700;

exports.Validation = Validation;
exports.Strategy = Strategy;
exports.FormStatus = FormStatus;
exports.ReactUpdate = ReactUpdate;
exports.defaultDebounceInterval = defaultDebounceInterval;
exports.Make = Make;
/* react Not a pure module */
